import BankAccount from './BankAccount'
import Payment from './Payment'

export default class NewBankAccount {
  constructor(component) {
    this.component = component
  }
  name() {
    return 'new-bank-account'
  }
  handle(event) {
    if(event.cancel) {
      this.component.modalExpanded = false
      this.component.transaction_controller = new BankAccount(this.component)
      return
    }
    if(event.newBankAccount) {
      this.component.selected_bank_account = event.newBankAccount
      this.component.modalExpanded = false
      this.component.transaction_controller = new Payment(this.component)
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/NewTransaction/NewBankAccount.js